import fp from "lodash/fp"

import type { Theme } from "@mui/material"

import type { PiePlotView, StaticPlotDef } from "types/dashboard.types"
import { darkTheme } from "styles/themes"
import { pieView } from "../base/views"

const devicesStatusPlotView: (theme: Theme) => PiePlotView = (theme: Theme) =>
  fp.merge(pieView, {
    name: "Devices by status",
    nameKey: "DEVICES_BY_STATUS",
    helpTooltip: [
      "device.REPORTING_STATUS_WITH_TITLE",
      "device.ACTIVE_STATUS_WITH_TITLE",
      "device.INTERMITTENT_STATUS_WITH_TITLE",
      "device.INACTIVE_STATUS_WITH_TITLE",
      "device.UNKNOWN_STATUS_WITH_TITLE",
    ],
    properties: {
      colors: [
        { value: "reporting", hex: theme.palette.deviceStatus.reporting.main },
        { value: "active", hex: theme.palette.deviceStatus.active.main },
        { value: "intermittent", hex: theme.palette.deviceStatus.intermittent.main },
        { value: "inactive", hex: theme.palette.deviceStatus.inactive.main },
        { value: "unknown", hex: theme.palette.deviceStatus.unknown.main },
      ],
    },
  })

export const devicesStatusPlotDef: (theme: Theme) => StaticPlotDef = (theme: Theme) => ({
  view: devicesStatusPlotView(theme),
  draggable: false,
})

const devicesAlertStatusPlotView = fp.merge(pieView, {
  name: "Devices by alert status",
  nameKey: "DEVICES_BY_ALERT_STATUS",
  properties: {
    colors: [
      { value: "triggered", hex: darkTheme.palette.error.main },
      {
        value: "notTriggered",
        hex: darkTheme.palette.secondary.main,
      },
    ],
  },
})

export const devicesAlertStatusPlotDef: StaticPlotDef = {
  view: devicesAlertStatusPlotView,
  draggable: false,
}

const devicesBatteryLevelPlotView = fp.merge(pieView, {
  name: "Devices by battery level",
  nameKey: "DEVICES_BY_BATTERY_LEVEL",
  properties: {
    colors: [
      { value: "batteryOk", hex: darkTheme.palette.secondary.main },
      { value: "batteryWarning", hex: darkTheme.palette.warning.main },
      { value: "batteryError", hex: darkTheme.palette.error.main },
    ],
  },
})

export const devicesBatteryLevelPlotDef: StaticPlotDef = {
  view: devicesBatteryLevelPlotView,
  draggable: false,
}
